import api from "./api";
import { message } from "antd";

const handleError = (error) => {
  const msg =
    error.response?.data?.DisplayMessage ||
    error.response?.data?.Message ||
    error.message ||
    "Something went wrong";
  throw new Error(msg);
};

export const getTotVendorListApi = async () => {
  try {
    const response = await api.get(`VendorRegistration/gettotVendor`);
    return response?.data || [];
  } catch (error) {
    handleError(error);
  }
};

export const getTotDocumentApi = async (vendorGUID) => {
  try {
    const response = await api.get(
      `VendorRegistration/gettotDocument?vendorguid=${vendorGUID}`
    );
    return response?.data;
  } catch (error) {
    handleError(error);
  }
};

export const getBlobDownloadUrlApi = async (fileName) => {
  try {
    const response = await api.get(`FileUpload/blob/download`, {
      params: { fileName },
    });
    return response?.data;
  } catch (error) {
    handleError(error);
  }
};

export const uploadBlobApi = async (file) => {
  try {
    const formData = new FormData();
    formData.append("FileName", file.name);
    formData.append("File", file);

    const response = await api.post(`FileUpload/blob/upload`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return response?.data;
  } catch (error) {
    handleError(error);
  }
};

export const uploadTotDocumentApi = async (vendorGUID, totAgreement) => {
  try {
    const response = await api.post(`VendorRegistration/uploadtotdocument`, {
      vendorGUID,
      totAgreement,
    });

    if (response?.data?.IsSuccess === true) {
      message.success(
        response?.data?.Data?.[0]?.message ||
          response?.data?.DisplayMessage ||
          "Document uploaded successfully"
      );
    } else {
      message.error(response?.data?.DisplayMessage || "Upload failed");
    }

    return response?.data;
  } catch (error) {
    handleError(error);
  }
};